import React from "react";
import CrudManager from "@/components/admin/CrudManager";

export default function Distributors() {
  return (
    <CrudManager
      title="Distributors"
      description="Manage authorized distributor listings shown on Find Distributor."
      endpoint="distributors"
      fields={[
        { name: "name", label: "Contact Name", type: "text" },
        { name: "company", label: "Company Name", type: "text" },
        { name: "address", label: "Address", type: "textarea", rows: 2 },
        { name: "city", label: "City", type: "text" },
        { name: "state", label: "State", type: "text" },
        { name: "phone", label: "Phone", type: "text" },
        { name: "email", label: "Email", type: "text" },
        { name: "lat", label: "Latitude (optional)", type: "text" },
        { name: "lng", label: "Longitude (optional)", type: "text" },
        { name: "order", label: "Display Order", type: "number" },
        { name: "active", label: "Visible", type: "switch" },
      ]}
      columns={[
        { name: "company", label: "Company", type: "text" },
        { name: "city", label: "City", type: "text" },
        { name: "phone", label: "Phone", type: "text" },
        { name: "active", label: "Status", type: "switch" },
      ]}
    />
  );
}
